import { toast } from 'react-toastify';
import axios from '../../axios';
import {
   ADD_ISSUE,
   UPDATE_ISSUE,
   GET_ISSUES,
   GET_ISSUE,
   DELETE_ISSUE,
   CLEAR_ISSUE,
   GET_ISSUE_DOCUMENT,
} from '../types';

export const addIssue = (formData) => async (dispatch) => {
   try {
      dispatch({ type: 'SET_LOADING', payload: true });
      const res = await axios.post(`/issue/add`, formData);
      if (res.data.code === 1) {
         dispatch({
            type: ADD_ISSUE,
            payload: {
               data: res.data.data || [],
               pagination: res.data.pagination || {},
               totalCount: res.data.totalCount || 0,
            },
         });
         setTimeout(() => {
            toast.success('Issue added successfully!');
         }, 1000);
         return res.data;
      }
      if (res.data.code === 2) {
         setTimeout(() => {
            toast.warn(res.data.message);
         }, 1000);
         return res.data;
      }
   } catch (err) {
      if (err.response.data.message) {
         toast.error(err.response.data.message);
         return err.response.data;
      }
      return err.response.data;
   }
};

export const updateIssue = (formData) => async (dispatch) => {
   try {
      dispatch({ type: 'SET_LOADING', payload: true });
      const res = await axios.post(`/issue/update`, formData);
      if (res.data.code === 1) {
         dispatch({ type: UPDATE_ISSUE, payload: res.data.data });
         setTimeout(() => {
            toast.success('Issue updated successfully!');
         }, 1000);
         return res.data;
      }
      if (res.data.code === 2) {
         setTimeout(() => {
            toast.warn(res.data.message);
         }, 1000);
         return res.data;
      }
   } catch (err) {
      if (err.response.data.message) {
         toast.error(err.response.data.message);
         return err.response.data;
      }
      return err.response.data;
   }
};

export const deleteIssue = (id) => async (dispatch) => {
   try {
      dispatch({ type: 'SET_LOADING', payload: true });
      const res = await axios.post(`/issue/delete/${id}`);
      if (res.data.code === 1) {
         dispatch({
            type: DELETE_ISSUE,
            payload: { id },
         });
         setTimeout(() => {
            toast.success('Issue deleted successfully!');
         }, 1000);
      }
      if (res.data.code === 2) {
         setTimeout(() => {
            toast.warn(res.data.message);
         }, 1000);
      }
   } catch (err) {
      if (err.response.data.message) {
         toast.error(err.response.data.message);
      }
   }
};

export const getIssues = (params) => async (dispatch) => {
   try {
      dispatch({ type: 'SET_LOADING', payload: true });
      const res = await axios.get(`/issue/all`, { params });
      if (res.data.code === 1) {
         dispatch({
            type: GET_ISSUES,
            payload: {
               data: res.data.data || [],
               pagination: res.data.pagination || {},
               totalCount: res.data.totalCount || 0,
            },
         });
      }
   } catch (err) {
      console.error('getIssues err', err);
   }
};

export const getIssuesDocument = (params) => async (dispatch) => {
   try {
      dispatch({ type: 'SET_LOADING', payload: true });
      const res = await axios.get(`/issue/issue-document`, { params });
      if (res.data.code === 1) {
         dispatch({
            type: GET_ISSUE_DOCUMENT,
            payload: {
               data: res.data.data || [],
               pagination: res.data.pagination || {},
               totalCount: res.data.totalCount || 0,
            },
         });
      }
   } catch (err) {
      console.error('getIssues err', err);
   }
};

export const getIssue = (id) => async (dispatch) => {
   try {
      dispatch({ type: 'SET_LOADING', payload: true });
      const res = await axios.get(`/issue/${id}`);
      if (res.data.code === 1) {
         dispatch({
            type: GET_ISSUE,
            payload: res.data.data,
            totalCount: res.data.totalCount,
         });
      }
   } catch (err) {
      console.error('getIssue err', err);
   }
};

export const issueClear = () => async (dispatch) => {
   dispatch({ type: CLEAR_ISSUE, payload: null });
};
